import { lightsProgrammingReducer } from './services/lights.service';

export const QUICKSTART_LIGHTS_REDUCERS: any = {
  lightsProgramming: lightsProgrammingReducer
};



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/quickstart-lights.stores.ts